<div class="basic-content__text__info {{fontSize}}" [innerHTML]="textToDisplay"></div>